import { USP_VALUES, UspType } from "../shared/values";

export interface TeamMember {
  name: string;
  title: string;
  imageSrc: string;
  linkedinUrl: string;
}

export interface AboutCardData {
  title: string;
  description: string;
  imageSrc: string;
}

export interface HeadlineData {
  title: string;
  subtitle: string;
}

export interface AboutUsContent {
  headline: HeadlineData;
  mission: AboutCardData;
  vision: AboutCardData;
  teamMembers: TeamMember[];
}

export const ABOUT_US_CONTENT: AboutUsContent = {
  headline: {
    title: "About Us",
    subtitle: "We turned our mutual passion for coding into a software company."
  },
  mission: {
    title: "Mission",
    description: "Our mission is to drive our clients forward. We are committed to build strong partnerships through collaboration, transparency and a focus on mutual growth.",
    imageSrc: "../mission.jpg"
  },
  vision: {
    title: "Vision",
    description: "We aim to become a top software partner for building and supporting great ideas. That is precisely why we are dedicated to extend a value-driven team of developers from diverse disciplines and cultures.",
    imageSrc: "../vision.jpg"
  },
  teamMembers: [
    {
      name: "Elzon Avdiu",
      title: "Founder / Director of Business Development",
      imageSrc: "../elzon-pp.jpg",
      linkedinUrl: "https://www.linkedin.com/in/elzon-avdiu"
    },
    {
      name: "Arnit Gashi",
      title: "Principal Software Engineer",
      imageSrc: "../arnit-pp.png",
      linkedinUrl: "https://linkedin.com/in/arnit-gashi-a372a11aa"
    },
    {
      name: "Erion Avdiu",
      title: "Principal Software Engineer",
      imageSrc: "../erion-pp.png",
      linkedinUrl: "https://linkedin.com/in/erionavdiu"
    },
    {
      name: "Adonis Shabani",
      title: "Principal Software Engineer",
      imageSrc: "../adonis-pp.png",
      linkedinUrl: "https://www.linkedin.com/in/adonis-shabani-82a84617b"
    }
  ]
}; 